export default __webpack_public_path__ + "static/media/Ki.217c7117.svg";